import React from "react"

export const FilterIcon = ({ color = "#034055", size = 1 }) => {
  return (
    <svg
      width={size * 26}
      height={size * 26}
      viewBox="0 0 26 26"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        strokeMiterlimit="10"
        strokeWidth="3"
        stroke={color}
        d="M22.7,2.3H3.3l5.9,10.6v7.6l7.6,4.2V12.9L22.7,2.3z"
      />
    </svg>
  )
}
